import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import { UploadFile } from 'types'
import { convertBytesNumberToString } from 'utils/transforms/number'

const checkFileMinSize = (file: UploadFile, minSize?: number) => {
  if (!minSize) return true
  return minSize < Number(file.size)
}

const checkFileMaxSize = (file: UploadFile, maxSize?: number) => {
  if (!maxSize) return true
  return maxSize > Number(file.size)
}

const checkFileExtension = (file: UploadFile, extensions?: string[]) => {
  if (!extensions) return true
  const currentAcceptFiles = (extensions || []).map((file) => file.toLowerCase())

  if (currentAcceptFiles.length === 0) return true
  return currentAcceptFiles.includes(file.extension as string)
}

function dynamicSingleFileUploadValidators(file: UploadFile, question: CustomFormQuestion): string {
  let errorMessage = ''

  if (question.validation) {
    const { extensions, min, max } = question.validation
    if (!checkFileExtension(file, extensions)) {
      errorMessage = `Extensão não permitida (${file.extension?.toUpperCase()})`
    }
    if (!checkFileMaxSize(file, max)) {
      errorMessage = `Arquivo maior que o permitido (tamanho do seu arquivo: ${convertBytesNumberToString(file.size!)})`
    }
    if (!checkFileMinSize(file, min)) {
      errorMessage = `Arquivo menor que o permitido (tamanho do seu arquivo: ${convertBytesNumberToString(file.size!)})`
    }
  }

  return errorMessage
}

type ValidateSingleFileUploadOnCustomFormParams = {
  file: string[] | UploadFile
  question: CustomFormQuestion
}

export default function validateSingleFileUploadOnCustomForm({
  file,
  question,
}: ValidateSingleFileUploadOnCustomFormParams) {
  let error = ''
  if (Array.isArray(file)) {
    if (file.length === 0 && question.is_required) {
      error = 'Este campo é obrigatório'
    }
  } else {
    const errorMessage = dynamicSingleFileUploadValidators(file, question)
    if (errorMessage !== '') {
      error = errorMessage
    }
  }

  return error
}
